import React from 'react';

const Fb = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 2.357v17.286A2.358 2.358 0 0 1 19.643 22h-4.189v-8.702h2.976l.427-3.32h-3.403v-2.12c0-.963.265-1.616 1.645-1.616h1.758V3.275a23.633 23.633 0 0 0-2.563-.132c-2.534 0-4.273 1.547-4.273 4.39v2.45H9.036v3.32h2.99V22H2.357A2.358 2.358 0 0 1 0 19.643V2.357A2.358 2.358 0 0 1 2.357 0h17.286A2.358 2.358 0 0 1 22 2.357z"
      fill="currentColor"
    />
  </svg>
);

export default Fb;
